/* eslint-disable import/prefer-default-export */
export const FORWARD_EMAIL_TEMPLATE_OPTIONS = [
  { label: 'Reply within email client', value: 'reply_within_email_client' },
  { label: 'Reply within web app', value: 'reply_within_web_app' },
];
